export default "__VITE_ASSET__DG$SMPiY__"